import * as React from 'react'

function CopyIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={12.6} height={12.6} viewBox="0 0 12.6 12.6" {...props}>
      <g data-name="Group 52572" stroke="CurrentColor" strokeWidth={1.2}>
        <g data-name="Rectangle 7487" transform="translate(-1230.9 -296.9) translate(1233 299)" fill="#fff">
          <path stroke="none" d="M0 0H10.5V10.5H0z" />
          <path fill="none" d="M0.6 0.6H9.9V9.9H0.6z" />
        </g>
        <path data-name="Path 65284" d="M1231.5 306.5v-9h9" fill="none" transform="translate(-1230.9 -296.9)" />
      </g>
    </svg>
  )
}

export default CopyIcon
